/*
 * EnviAir — Product tabs
 *
 * Progressive enhancement: the markup ships with every panel visible, and this
 * hides the inactive ones on init. If the script never runs, the section still
 * reads as stacked content instead of collapsing to one panel.
 *
 * Implements the WAI-ARIA tabs pattern — roving tabindex, arrow keys, Home/End.
 */
(function () {
  function setup(root) {
    if (root.dataset.eaTabsReady === 'true') return;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[role="tabpanel"]'));

    // Nothing to switch between — leave the content as plain stacked markup.
    if (tabs.length < 2 || tabs.length !== panels.length) return;

    root.dataset.eaTabsReady = 'true';

    function select(index, moveFocus) {
      tabs.forEach(function (tab, i) {
        var active = i === index;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        // Roving tabindex: only the active tab is in the tab order.
        tab.tabIndex = active ? 0 : -1;
        panels[i].hidden = !active;
      });

      if (moveFocus) tabs[index].focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        select(i, false);
      });

      tab.addEventListener('keydown', function (event) {
        var last = tabs.length - 1;
        var next = null;

        switch (event.key) {
          case 'ArrowRight':
            next = i === last ? 0 : i + 1;
            break;
          case 'ArrowLeft':
            next = i === 0 ? last : i - 1;
            break;
          case 'Home':
            next = 0;
            break;
          case 'End':
            next = last;
            break;
          default:
            return;
        }

        event.preventDefault();
        select(next, true);
      });
    });

    select(0, false);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-ea-tabs]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  // Quick view injects its panel after load, so it needs a way to wire up
  // tabs that were never in the document when this ran.
  window.EnviAirTabs = { init: init };

  // Selecting a block in the theme editor should reveal its panel.
  document.addEventListener('shopify:block:select', function (event) {
    var tab = event.target.closest('[role="tab"]');
    if (tab && tab.getAttribute('aria-selected') !== 'true') tab.click();
  });
})();
